module.exports = __webpack_public_path__ + "static/media/healthymood-banner.29bc5252.jpg";